import { setPusherClient } from "react-pusher"
import Pusher from "pusher-js"
import { PUSHER_CLUSTER, PUSHER_KEY } from "./constants"

export const pusherClient = new Pusher(PUSHER_KEY, {
  cluster: PUSHER_CLUSTER,
})

setPusherClient(pusherClient)
